const RoleGetter = {
  roles: (state) => state.roles,
  permissions: (state) => state.permissions
};

export default RoleGetter;
